/**
 * Include your custom JavaScript here.
 */

/* =========================================================================
   HIDE UPCHARGE APP FEES ON NON-CART PAGES
   The UpCharge app injects fee elements into .card__section globally.
   On non-cart pages (collections, etc.) these are unwanted. Hide them.
   ========================================================================= */
(function () {
  "use strict";

  // Only run on non-cart pages
  if (!window.theme || window.theme.pageType === "cart") return;

  // Fee text pattern: label followed by $XX.XX
  var feePattern = /(?:Surcharge|Deposit|Fee)\s*\$[\d,]+\.\d{2}/i;
  var priceOnlyPattern = /^\s*[\?\s]*[A-Za-z\s]+\$[\d,]+\.\d{2}\s*$/;

  function hideAppFees() {
    // Search multiple container levels where the app might inject
    var containers = document.querySelectorAll(
      ".card__section, .card, .collection__sidebar, .sidebar",
    );
    for (var s = 0; s < containers.length; s++) {
      var children = containers[s].children;
      for (var i = 0; i < children.length; i++) {
        var child = children[i];
        if (child.getAttribute("data-fee-hidden")) continue;
        var text = (child.textContent || "").trim();
        // Hide if the element's text matches a fee pattern
        if (feePattern.test(text) || priceOnlyPattern.test(text)) {
          child.style.display = "none";
          child.setAttribute("data-fee-hidden", "true");
        }
      }
    }
  }

  // Run immediately
  hideAppFees();

  // Observer for async injections
  var observer = new MutationObserver(function () {
    hideAppFees();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Poll fallback
  var count = 0;
  var interval = setInterval(function () {
    hideAppFees();
    count++;
    if (count >= 15) clearInterval(interval);
  }, 500);
})();

/* =========================================================================
   SURCHARGE FEE RELOCATION
   Finds app-injected fee elements in .cart-recap, extracts their label
   and price text, hides the originals, and renders clean table-like rows
   in the #deposits-surcharges-card.
   ========================================================================= */
(function () {
  "use strict";

  if (window.theme && window.theme.pageType !== "cart") return;

  var surchargesCard = document.getElementById("deposits-surcharges-card");
  var feeRowsContainer = document.getElementById("surcharges-fee-rows");
  if (!surchargesCard || !feeRowsContainer) return;

  var cartRecap = document.querySelector(".cart-recap");
  if (!cartRecap) return;

  // Known theme selectors at each level of .cart-recap hierarchy.
  var KNOWN_CHILDREN = {
    ".cart-recap": [".cart-recap__scroller"],
    ".cart-recap__scroller": [".card", ".cart-recap__secure-payment"],
    ".cart-recap .card": [".card__section"],
    ".cart-recap .card__section": [
      ".cart-recap__price-line",
      ".cart-recap__amount-saved",
      ".cart-recap__note",
      ".cart-recap__notices",
      ".cart-recap__checkout",
      'input[type="hidden"]',
    ],
  };

  function isKnownChild(child, parentSelector) {
    if (child.nodeType !== 1) return true;
    var allowedSelectors = KNOWN_CHILDREN[parentSelector];
    if (!allowedSelectors) return true;
    for (var i = 0; i < allowedSelectors.length; i++) {
      if (child.matches(allowedSelectors[i])) return true;
    }
    return false;
  }

  function getContainersForLevel(parentSelector) {
    if (parentSelector === ".cart-recap") return [cartRecap];
    if (parentSelector === ".cart-recap__scroller")
      return cartRecap.querySelectorAll(".cart-recap__scroller");
    if (parentSelector === ".cart-recap .card")
      return cartRecap.querySelectorAll(".card");
    if (parentSelector === ".cart-recap .card__section")
      return cartRecap.querySelectorAll(".card__section");
    return [];
  }

  // Extract ALL fee label/price pairs from an element, including descriptions.
  // Returns an array of { label, price, description } objects (may be empty).
  function extractAllFees(el) {
    var text = el.textContent || "";
    var results = [];
    var regex = /(\$[\d,]+\.\d{2})/g;
    var match;
    var lastEnd = 0;
    var positions = [];

    while ((match = regex.exec(text)) !== null) {
      positions.push({
        index: match.index,
        length: match[0].length,
        price: match[1],
      });
    }

    for (var p = 0; p < positions.length; p++) {
      var pos = positions[p];
      var labelText = text
        .substring(lastEnd, pos.index)
        .replace(/^\s+|\s+$/g, "");
      // Remove tooltip characters like "?"
      labelText = labelText.replace(/^[\?\s]+/, "").replace(/[\?\s]+$/, "");

      // Description: only text AFTER the LAST price is a real description.
      // Text between consecutive prices is the next fee's label, not a description.
      var descText = "";
      if (p === positions.length - 1) {
        var descStart = pos.index + pos.length;
        descText = text.substring(descStart).replace(/^\s+|\s+$/g, "");
        descText = descText.replace(/^[\?\s:]+/, "").replace(/[\?\s]+$/, "");
      }

      if (labelText) {
        results.push({
          label: labelText,
          price: pos.price,
          description: descText,
        });
      }
      lastEnd = pos.index + pos.length;
    }

    // Hardcoded fee descriptions keyed by label (case-insensitive partial match)
    var FEE_DESCRIPTIONS = {
      "fuel surcharge":
        "Due to ongoing fluctuations in fuel and transportation costs, a temporary surcharge has been applied to help maintain reliable service levels. This fee is reviewed regularly and adjusted as market conditions change.",
      "order flexibility deposit":
        "A deposit accompanying your order. Used for adding items, substitutions, or weighted products. Refunded if unused.",
    };

    for (var ri = 0; ri < results.length; ri++) {
      if (!results[ri].description) {
        var lowerLabel = results[ri].label.toLowerCase();
        for (var key in FEE_DESCRIPTIONS) {
          if (lowerLabel.indexOf(key) !== -1) {
            results[ri].description = FEE_DESCRIPTIONS[key];
            break;
          }
        }
      }
    }

    return results;
  }

  // Keep track of what we've already processed
  var processedElements = new Set();
  var isRunning = false;

  function findAndRelocateFees() {
    if (isRunning) return;
    isRunning = true;
    var levels = Object.keys(KNOWN_CHILDREN);
    var foundFees = [];

    for (var l = 0; l < levels.length; l++) {
      var parentSelector = levels[l];
      var containers = getContainersForLevel(parentSelector);

      for (var c = 0; c < containers.length; c++) {
        var container = containers[c];
        var children = Array.prototype.slice.call(container.children);
        for (var i = 0; i < children.length; i++) {
          var child = children[i];
          if (isKnownChild(child, parentSelector)) continue;
          if (surchargesCard.contains(child)) continue;
          if (processedElements.has(child)) {
            // Already processed but check if text changed
            continue;
          }

          var fees = extractAllFees(child);
          if (fees.length > 0) {
            for (var fi = 0; fi < fees.length; fi++) {
              foundFees.push({
                element: child,
                label: fees[fi].label,
                price: fees[fi].price,
                description: fees[fi].description || "",
              });
            }
            processedElements.add(child);
          }
        }
      }
    }

    if (foundFees.length > 0) {
      // Hide originals and build clean rows
      for (var f = 0; f < foundFees.length; f++) {
        var fee = foundFees[f];
        // Hide original element
        fee.element.style.display = "none";

        // Check if we already created a row for this label
        var existingRow = feeRowsContainer.querySelector(
          '[data-fee-label="' + fee.label.replace(/"/g, "&quot;") + '"]',
        );
        if (existingRow) {
          // Update price if changed
          var priceEl = existingRow.querySelector(".fee-row__price");
          if (priceEl) priceEl.textContent = fee.price;
          continue;
        }

        // Build expandable row
        var row = document.createElement("div");
        row.className = "fee-row";
        row.setAttribute("data-fee-label", fee.label);

        // Header: label-wrap (label + chevron) and price
        var header = document.createElement("div");
        header.className = "fee-row__header";

        var labelWrap = document.createElement("span");
        labelWrap.className = "fee-row__label-wrap";

        var labelSpan = document.createElement("span");
        labelSpan.className = "fee-row__label";
        labelSpan.textContent = fee.label;
        labelWrap.appendChild(labelSpan);

        // Chevron SVG
        if (fee.description) {
          var chevron = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "svg",
          );
          chevron.setAttribute("class", "fee-row__chevron");
          chevron.setAttribute("viewBox", "0 0 24 24");
          var polyline = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "polyline",
          );
          polyline.setAttribute("points", "6 9 12 15 18 9");
          chevron.appendChild(polyline);
          labelWrap.appendChild(chevron);
        }

        header.appendChild(labelWrap);

        var priceSpan = document.createElement("span");
        priceSpan.className = "fee-row__price";
        priceSpan.textContent = fee.price;
        header.appendChild(priceSpan);

        row.appendChild(header);

        // Description (hidden by default, revealed on click)
        if (fee.description) {
          var descDiv = document.createElement("div");
          descDiv.className = "fee-row__description";

          var descText = document.createElement("span");
          descText.className = "fee-row__description-text";
          descText.textContent = fee.description;
          descDiv.appendChild(descText);

          row.appendChild(descDiv);

          // Click handler for expand/collapse
          row.addEventListener(
            "click",
            (function (r, d) {
              return function () {
                var isExpanded = r.classList.contains("is-expanded");
                if (isExpanded) {
                  d.style.maxHeight = "0";
                  r.classList.remove("is-expanded");
                } else {
                  // Add class first so padding is applied, then measure
                  r.classList.add("is-expanded");
                  d.style.maxHeight = d.scrollHeight + 20 + "px";
                }
              };
            })(row, descDiv),
          );
        }

        feeRowsContainer.appendChild(row);
      }
    }

    // Show/hide the card and update dual totals
    var hasFees = feeRowsContainer.children.length > 0;
    surchargesCard.style.display = hasFees ? "" : "none";
    updateDualTotals(hasFees);

    // Release guard after a tick so observer-triggered mutations from our
    // own DOM writes don't cause re-entrant calls (the observer fires
    // synchronously for mutations we just made).
    setTimeout(function () {
      isRunning = false;
    }, 0);
  }

  /* -------------------------------------------------------------------
     DUAL TOTALS: "Subtotal" (products only) vs
                  "Total" (full cart total incl. deposits & surcharges)
     ------------------------------------------------------------------- */
  function parseMoney(str) {
    if (!str) return 0;
    // Strip everything except digits and decimal point
    var cleaned = str.replace(/[^0-9.]/g, "");
    return parseFloat(cleaned) || 0;
  }

  function formatMoney(cents) {
    // Use the theme's moneyFormat if available, otherwise default $X.XX
    var amount = (cents / 100).toFixed(2);
    if (window.theme && window.theme.moneyFormat) {
      return window.theme.moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/, amount)
        .replace(
          /\{\{\s*amount_with_comma_separator\s*\}\}/,
          amount.replace(".", ","),
        )
        .replace(
          /\{\{\s*amount_no_decimals\s*\}\}/,
          Math.round(cents / 100).toString(),
        )
        .replace(
          /\{\{\s*amount_with_comma_separator_no_decimals\s*\}\}/,
          Math.round(cents / 100)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        )
        .replace(
          /\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/,
          Math.round(cents / 100)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        );
    }
    return "$" + amount;
  }

  function updateDualTotals(hasSurcharges) {
    var orderTotalEl = document.getElementById("cart-order-total");
    var fullTotalEl = document.getElementById("cart-full-total");
    if (!orderTotalEl || !fullTotalEl) return;

    if (!hasSurcharges) {
      // No surcharges: single "Total" line, hide order total
      orderTotalEl.style.display = "none";
      fullTotalEl.querySelector(".cart-recap__price-line-label").textContent =
        "Total";
      return;
    }

    // Sum surcharge amounts from the relocated fee rows
    var surchargeTotal = 0;
    var rows = feeRowsContainer.querySelectorAll(".fee-row__price");
    for (var i = 0; i < rows.length; i++) {
      surchargeTotal += parseMoney(rows[i].textContent);
    }

    // Parse the full cart total (in dollars)
    var fullTotalPriceEl = fullTotalEl.querySelector(
      ".cart-recap__price-line-price",
    );
    var cartTotalDollars = parseMoney(fullTotalPriceEl.textContent);

    // Order total = full cart total minus surcharges
    var orderTotalDollars = cartTotalDollars - surchargeTotal;
    if (orderTotalDollars < 0) orderTotalDollars = 0;

    // Convert to cents for formatting
    var orderTotalCents = Math.round(orderTotalDollars * 100);

    // Update "Order Total" line
    var orderTotalPriceEl = orderTotalEl.querySelector(
      ".cart-recap__price-line-price",
    );
    orderTotalPriceEl.textContent = formatMoney(orderTotalCents);
    orderTotalEl.style.display = "";

    // Relabel the full total
    fullTotalEl.querySelector(".cart-recap__price-line-label").textContent =
      "Total incl. Deposit";
  }

  // Initial run
  findAndRelocateFees();

  // Watch for async app injections
  var observer = new MutationObserver(function (mutations) {
    var hasRelevantChange = false;
    for (var i = 0; i < mutations.length; i++) {
      var target = mutations[i].target;
      if (!surchargesCard.contains(target)) {
        hasRelevantChange = true;
        break;
      }
    }
    if (hasRelevantChange) {
      findAndRelocateFees();
    }
  });

  observer.observe(cartRecap, { childList: true, subtree: true });

  // Poll fallback
  var pollCount = 0;
  var pollInterval = setInterval(function () {
    findAndRelocateFees();
    pollCount++;
    if (pollCount >= 20) clearInterval(pollInterval);
  }, 500);

  // Re-run after AJAX cart re-renders.
  // The theme replaces originalCart.innerHTML after each quantity update,
  // which fires childList mutations on the stable [data-section-type="cart"]
  // section element. Detect this and re-acquire stale references + re-run.
  var cartSection = document.querySelector('[data-section-type="cart"]');
  if (cartSection) {
    var sectionObserver = new MutationObserver(function (mutations) {
      var hasAddedNodes = false;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length > 0) {
          hasAddedNodes = true;
          break;
        }
      }
      if (!hasAddedNodes) return;

      var newCartRecap = document.querySelector('.cart-recap');
      if (!newCartRecap || newCartRecap === cartRecap) return;

      // Re-acquire all references that were invalidated by the innerHTML swap
      cartRecap        = newCartRecap;
      surchargesCard   = document.getElementById('deposits-surcharges-card');
      feeRowsContainer = document.getElementById('surcharges-fee-rows');
      if (!surchargesCard || !feeRowsContainer) return;

      processedElements = new Set();  // reset so new nodes can be processed
      observer.disconnect();          // detach from old (now detached) cartRecap
      observer.observe(cartRecap, { childList: true, subtree: true }); // re-attach to new one
      findAndRelocateFees();          // re-run the existing logic unchanged
    });
    sectionObserver.observe(cartSection, { childList: true, subtree: false });
  }
})();
